import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-gradient-to-r from-green-700 via-green-600 to-emerald-600 shadow-xl relative z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center h-20">
          {/* Logo avec animation */}
          <div className="flex-shrink-0 flex items-center space-x-3 bg-white p-1.5 rounded-lg shadow-md mr-8 hover:shadow-lg transition-all duration-300">
            <img
              className="h-10 w-auto hover:scale-105 transition-transform duration-300"
              src="/anrp.png"
              alt="ANRP Logo"
            />
            <div className="w-px h-8 bg-gray-200"></div>
            <span className="hidden sm:block text-emerald-700 font-semibold">SIND</span>
          </div>

          {/* Navigation Desktop */}
          <nav className="hidden md:flex space-x-6">
            <Link 
              to="/" 
              className="text-white hover:text-emerald-100 px-4 py-2 rounded-lg text-base font-semibold transition-all hover:bg-emerald-600/30 flex items-center group"
            >
              <span className="relative">
                Accueil
                <span className="absolute inset-x-0 bottom-0 h-0.5 bg-emerald-200 transform scale-x-0 group-hover:scale-x-100 transition-transform"></span>
              </span>
            </Link>
            <Link 
              to="/about" 
              className="text-white hover:text-emerald-100 px-4 py-2 rounded-lg text-base font-semibold transition-all hover:bg-emerald-600/30 flex items-center group"
            >
              <span className="relative">
                À propos
                <span className="absolute inset-x-0 bottom-0 h-0.5 bg-emerald-200 transform scale-x-0 group-hover:scale-x-100 transition-transform"></span>
              </span>
            </Link>
          </nav>

          {/* Bouton connexion */}
          <div className="ml-auto">
            <Link 
              to="/login" 
              className="bg-white text-emerald-700 hover:bg-emerald-50 px-6 py-2 rounded-lg text-base font-semibold transition-all hover:shadow-lg border border-emerald-100 flex items-center gap-2"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M3 3a1 1 0 011 1v12a1 1 0 11-2 0V4a1 1 0 011-1zm7.707 3.293a1 1 0 010 1.414L9.414 9H17a1 1 0 110 2H9.414l1.293 1.293a1 1 0 01-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
              Connexion
            </Link>
          </div>

          {/* Menu mobile */}
          <div className="md:hidden ml-4">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-white hover:text-emerald-100 p-2 bg-emerald-600/30 rounded-lg transition-colors"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Menu mobile dropdown */}
        <div className={`md:hidden absolute inset-x-0 bg-green-700 transition-all duration-300 ease-in-out ${isMenuOpen ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-full pointer-events-none'}`}>
          <div className="px-4 pt-2 pb-3 space-y-2">
            <Link
              to="/"
              className="text-white hover:bg-emerald-600/30 block px-4 py-2 rounded-lg text-base font-medium transition-all"
              onClick={() => setIsMenuOpen(false)}
            >
              Accueil
            </Link>
            <Link
              to="/about"
              className="text-white hover:bg-emerald-600/30 block px-4 py-2 rounded-lg text-base font-medium transition-all"
              onClick={() => setIsMenuOpen(false)}
            >
              À propos
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;